export default __webpack_public_path__ + "static/media/search.c345ae6d.svg";